import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 bg-black/15 backdrop-blur-md  flex items-center justify-center z-[99999]">
      <div className="flex flex-col bg-mainBg backdrop-blur-md p-8 rounded-xl">
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}/images/logo.png`}
          alt="logo"
          className="w-40 mb-3"
        />
        <p className="text-slate-800 mt-4">Traitement en cours...</p>
      </div>
    </div>
  );
};

export default Loader;
